// @flow

import * as React from 'react';
import Head from 'next/head';
import { graphql, useFragment } from 'react-relay';
import { useLocale } from '../../hooks/locale';
import type { PageMeta_root$key } from './__generated__/PageMeta_root.graphql';

type Props = {|
  root: PageMeta_root$key,
  data?: { [string]: string | number, ... },
  fallbackTitle?: string,
  fallbackDescription?: string,
  canonical?: string,
|};

export const PageMeta = (props: Props): React.Node => {
  const { t, interpolate } = useLocale();

  const {
    fallbackTitle = t('defaultFallbackPageTitle'),
    fallbackDescription,
    data = {},
  } = props;

  const root = useFragment(
    graphql`
      fragment PageMeta_root on Query {
        cms {
          pageWithData(uid: $uid, lang: $lang) {
            page {
              title
              description
            }
          }
        }
      }
    `,
    props.root,
  );

  const page = root.cms.pageWithData?.page;

  const title = page?.title === '' ? null : page?.title;
  const description = page?.description === '' ? null : page?.description;

  return (
    <Head>
      <title>{title != null ? interpolate(title, data) : fallbackTitle}</title>
      {description != null ? (
        <meta name="description" content={interpolate(description, data)} />
      ) : fallbackDescription != null ? (
        <meta name="description" content={fallbackDescription} />
      ) : null}
    </Head>
  );
};
